module.exports = __webpack_public_path__ + "static/media/buy_interview_11.3ae6fd91.jpg";